module.exports = __webpack_public_path__ + "static/media/ethwalletlogo.9550da72.svg";